"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.admin = exports.swap = exports.initSwapper = void 0;
const web3_js_1 = require("@solana/web3.js");
const instructions_1 = require("./instructions");
const utils_1 = require("./utils");
const state_1 = require("./state");
const initSwapper = async (connection, govTokenPerCope, maxQuantity, feePayer, copeMint, govTokenMint, adminKey) => {
    let instructions = [];
    const swapperStateAccount = new web3_js_1.Account();
    const LEN = 146;
    console.log(`Swapper state account ${swapperStateAccount.publicKey.toBase58()}`);
    const balance = await connection.getMinimumBalanceForRentExemption(LEN);
    const createSwapperStateInstruction = web3_js_1.SystemProgram.createAccount({
        fromPubkey: feePayer,
        lamports: balance,
        newAccountPubkey: swapperStateAccount.publicKey,
        programId: utils_1.PROGRAM_ID,
        space: LEN,
    });
    instructions.push(createSwapperStateInstruction);
    const [swapper_signer, signer_nonce] = await web3_js_1.PublicKey.findProgramAddress([swapperStateAccount.publicKey.toBuffer()], utils_1.PROGRAM_ID);
    // Create COPE account
    const copeAccountInstruction = await utils_1.createAssociatedTokenAccount(feePayer, swapper_signer, copeMint);
    const copeAccount = await utils_1.findAssociatedTokenAddress(swapper_signer, copeMint);
    instructions.push(copeAccountInstruction);
    // Create gov token account
    const govAccountInstruction = await utils_1.createAssociatedTokenAccount(feePayer, swapper_signer, govTokenMint);
    instructions.push(govAccountInstruction);
    const initInstruction = new instructions_1.initSwapperInstruction({
        signer_nonce: signer_nonce,
        gov_token_per_cope: govTokenPerCope,
        max_quantity_per_wallet: maxQuantity,
    }).getInstruction(swapperStateAccount.publicKey, copeMint, govTokenMint, adminKey, copeAccount);
    instructions.push(initInstruction);
    return [instructions, [swapperStateAccount]];
};
exports.initSwapper = initSwapper;
const swap = async (connection, copeAmount, swapperStateAccount, claimer) => {
    let instructions = [];
    const state = await state_1.SwapperHeader.retrieve(connection, swapperStateAccount);
    const signerNonce = state.signer_nonce;
    const swapperSigner = await web3_js_1.PublicKey.createProgramAddress([swapperStateAccount.toBuffer(), Uint8Array.from([signerNonce])], utils_1.PROGRAM_ID);
    console.log("swapperSigner", swapperSigner.toBase58());
    // Swapper
    const swapperCopeAccount = await utils_1.findAssociatedTokenAddress(swapperSigner, state.copeMint);
    const swapperGovAccount = await utils_1.findAssociatedTokenAddress(swapperSigner, state.govTokenMint);
    // Claimer
    const claimerCopeAccount = await utils_1.findAssociatedTokenAddress(claimer, state.copeMint);
    const claimerCopeAccountInfo = await connection.getAccountInfo(claimerCopeAccount);
    const claimerGovAccount = await utils_1.findAssociatedTokenAddress(claimer, state.govTokenMint);
    const claimerGovAccountInfo = await connection.getAccountInfo(claimerGovAccount);
    if (!(claimerCopeAccountInfo === null || claimerCopeAccountInfo === void 0 ? void 0 : claimerCopeAccountInfo.data) || !(claimerGovAccountInfo === null || claimerGovAccountInfo === void 0 ? void 0 : claimerGovAccountInfo.data)) {
        // Account does not exist
        throw new Error("Associated token account does not exist");
    }
    let swapInst = new instructions_1.swapInstruction({
        copeAmount: copeAmount,
    }).getInstruction(swapperStateAccount, swapperSigner, swapperCopeAccount, swapperGovAccount, claimerCopeAccount, claimerGovAccount, claimer);
    instructions.push(swapInst);
    return instructions;
};
exports.swap = swap;
const admin = async (connection, copeAmountToWithdraw, govTokenToWithdraw, swapperStateAccount, adminAccount) => {
    let instructions = [];
    const state = await state_1.SwapperHeader.retrieve(connection, swapperStateAccount);
    const signerNonce = state.signer_nonce;
    const swapperSigner = await web3_js_1.PublicKey.createProgramAddress([swapperStateAccount.toBuffer(), Uint8Array.from([signerNonce])], utils_1.PROGRAM_ID);
    // Swapper
    const swapperCopeAccount = await utils_1.findAssociatedTokenAddress(swapperSigner, state.copeMint);
    const swapperGovAccount = await utils_1.findAssociatedTokenAddress(swapperSigner, state.govTokenMint);
    // Admin
    const adminCopeAccount = await utils_1.findAssociatedTokenAddress(adminAccount, state.copeMint);
    const adminCopeAccountInfo = await connection.getAccountInfo(adminCopeAccount);
    if (!(adminCopeAccountInfo === null || adminCopeAccountInfo === void 0 ? void 0 : adminCopeAccountInfo.data)) {
        const createCopeAccountInstruction = await utils_1.createAssociatedTokenAccount(adminAccount, adminAccount, state.copeMint);
        instructions.push(createCopeAccountInstruction);
    }
    const adminGovTokenAccount = await utils_1.findAssociatedTokenAddress(adminAccount, state.govTokenMint);
    const adminGovTokenAccountInfo = await connection.getAccountInfo(adminGovTokenAccount);
    if (!(adminGovTokenAccountInfo === null || adminGovTokenAccountInfo === void 0 ? void 0 : adminGovTokenAccountInfo.data)) {
        const createGoveTokenAccountInstruction = await utils_1.createAssociatedTokenAccount(adminAccount, adminAccount, state.govTokenMint);
        instructions.push(createGoveTokenAccountInstruction);
    }
    const adminInst = new instructions_1.adminInstruction({
        cope_amount_to_withdraw: copeAmountToWithdraw,
        gov_token_amount_to_withdraw: govTokenToWithdraw,
    }).getInstruction(swapperStateAccount, swapperSigner, swapperCopeAccount, swapperGovAccount, adminCopeAccount, adminGovTokenAccount, adminAccount);
    instructions.push(adminInst);
    return instructions;
};
exports.admin = admin;
//# sourceMappingURL=bindings.js.map